import script from "./BaseSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSelect.vue?vue&type=script&setup=true&lang=js"

import "./BaseSelect.vue?vue&type=style&index=0&id=e2df5704&lang=scss"

const __exports__ = script;

export default __exports__